import { render, staticRenderFns } from "./MallPointUploadCsv.vue?vue&type=template&id=92c15c28&scoped=true&"
import script from "./MallPointUploadCsv.vue?vue&type=script&lang=js&"
export * from "./MallPointUploadCsv.vue?vue&type=script&lang=js&"
import style0 from "./MallPointUploadCsv.vue?vue&type=style&index=0&id=92c15c28&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c15c28",
  null
  
)

export default component.exports